import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import Slide from './Slide';
import slideData from '../../data/SlideData';
import styles from './Slides.module.css';

function Slides() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') {
        setCurrent((prev) => (prev + 1) % slideData.length);
      } else if (e.key === 'ArrowLeft') {
        setCurrent((prev) => (prev - 1 + slideData.length) % slideData.length);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const { title, text, imageClass, buttonText, buttonAction } = slideData[current];

  return (
    <div className={styles.slidesWrapper}>
      {/* Breadcrumb dots */}
      <div className={styles.breadcrumbs}>
        {slideData.map((_, idx) => (
          <div
            key={idx}
            className={`${styles.breadcrumbDot} ${idx === current ? styles.active : ''}`}
          />
        ))}
      </div>

      {/* Slide content */}
      <div className={styles.slidesContainer}>
        <AnimatePresence mode="wait">
          <Slide
            key={current}
            title={title}
            text={text}
            imageClass={imageClass}
            buttonText={buttonText}
            buttonAction={buttonAction}
            // Pass styles as props
            slideClass={styles.slide}
            slideContentClass={styles.slideContent}
            slideTitleClass={styles.slideTitle}
            slideTextClass={styles.slideText}
          />
        </AnimatePresence>
      </div>

      {/* Navigation arrow */}
      <div
        className={styles.arrowRight}
        onClick={() => setCurrent((prev) => (prev + 1) % slideData.length)}
      >
        ➤
      </div>
    </div>
  );
}

export default Slides;